import SpringConfigs from 'utils/constants/swarm/spring-configs';

export const DEFAULT_CRYPTO_CURRENCY = 'FTN';
export const DEFAULT_FIAT_CURRENCY = 'USDT';
// in user profile we are getting USDT name as TUS
export const DEFAULT_FIAT_CURRENCY_ID = 'TUS';

export const CURRENCY_NAME_LIST_COUNT = 2;

export const PaymentMethodTypes = {
  POST: 'post',
  GET: 'get',
  IFRAME: 'iframe',
  FORM_DRAW: 'formdraw',
  MESSAGE: 'message'
};

export const StatusUrlNames = {
  CANCEL: 'cancel',
  FAIL: 'fail',
  PENDING: 'pending',
  SUCCESS: 'success'
};

export const DepositStatusMessages = {
  CANCEL: 'depositStatusMessageCancel',
  FAIL: 'depositStatusMessageFail',
  PENDING: 'depositStatusMessagePending',
  SUCCESS: 'depositStatusMessageDone'
};

export const WithdrawStatusMessages = {
  SUCCESS: 'withdrawSuccess'
};

export const PaymentStatusValues: Record<string, string> = {
  '-2': 'Rejected',
  '-1': 'Canceled',
  '0': 'New',
  ...(SpringConfigs.HIDE_WITHDRAWAL_ALLOWED_DATE ? {} : { '1': 'Allowed' }),
  '2': 'Pending',
  '3': 'Paid',
  '4': 'RollBacked'
};

export enum TWO_WALLET_TYPES {
  sport = 'sport',
  casino = 'casino'
}

export const IS_ACTIVE_TWO_WALLET =
  !SpringConfigs.CASINO_SPORTSBOOK_SWITCHER &&
  !!SpringConfigs.IS_TWO_WALLET_ACTIVE;

export const IS_ACTIVE_TWO_WALLET_SPORT = [0, 1].includes(
  SpringConfigs.CASINO_SPORTSBOOK_SWITCHER
)
  ? TWO_WALLET_TYPES.sport
  : TWO_WALLET_TYPES.casino;

export enum EBankVerificationTypes {
  BANK_ID = 1,
  DIIA = 2
}
export const MAX_MONTH_VALUE = 12;
export const YEAR_FORMAT_FOUR_DIGITS = 4;
export const TEST_LENGTH = 100;
export const CONFIRM_MODAL_PADDING = {
  _12: 12,
  _0: 0
};
export const CONFIRM_MODAL_WIDTH = {
  _350: 350,
  _420: 420
};
export const CASHOUT_AROUND = 0.01;
export const POS_WIN_AND_CASH_OUT_MIN_DIFFERENCE = 0.02;
/* eslint-disable no-magic-numbers */
export enum EPaymentStatusValuesTypes {
  Rejected = -2,
  Canceled = -1,
  New = 0,
  Allowed = 1,
  Pending = 2,
  Paid = 3,
  RollBacked = 4
}
